import angular from 'angular';
import uiRouter from 'angular-ui-router';
import resetPasswordFromPinService from './reset-password-frompin.service';
import resetPasswordFromPin from './reset-password-frompin.component';

export default
  angular.module('components.auth.resetPasswordFromPin', [
    uiRouter
  ])
    .component('resetPasswordFromPin', resetPasswordFromPin)
    .service('ResetPasswordFromPinService', resetPasswordFromPinService)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('resetPasswordFromPin', {
          parent: 'auth',
          url: '/reset-password-frompin',
          params: {
            userName: null
          },
          component: 'resetPasswordFromPin',
          resolve: {
            layout: () => 'column',
            flex: () => '100',
            credentials: $stateParams => ({
              UserName: $stateParams.userName
            })
          }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/auth/reset-password-frompin/reset-password-frompin.module.js